import React from 'react';

const VerticalDotsSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 1a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            fillRule="nonzero"
        />
    </svg>
);

VerticalDotsSvg.displayName = 'VerticalDotsSvg';
export default VerticalDotsSvg;
